import { Component } from '@angular/core';
import { AuthzoneComponent } from '../authzone/authzone.component';
import { AuthUserService } from '../services/auth-user-service/auth-user.service';

interface LoginCredentials {
  email: string;
  password: string;
};

interface LoginError {
  status: number;
  statusText: string;
  message: string;
}

@Component({
  selector: 'mcrit-gestio-login',
  templateUrl: 'login.component.html',
  styleUrls: ['login.component.css']
})
export class LoginComponent {
  public userData: LoginCredentials = {
    email: '',
    password: ''
  };

  public esticRec: boolean = true;
  public lastError: LoginError;
  public recuperarOK: boolean = false;

  public onSubmit() {
    this.lastError = null;
    this.authUserService.login(this.userData.email, this.userData.password);
  }

  constructor(private authUserService: AuthUserService) {
    this.authUserService = authUserService;
  }
  
}